<template>
  <v-container class="app-container--width-max">
    <v-alert
      color="var(--orange-100)"
      class="quote-expired-message ma-5"
      v-if="this.isExpired"
    >
      <div class="d-flex flex-no-wrap error-message">
        <div class="mr-3">
          <v-icon color="var(--orange-500)">mdi-alert</v-icon>
        </div>
        <div>
          <span class="font-weight-bold">Sorry!</span> This quote has expired.
          Please check all the details below are accurate and submit a new
          quote.
        </div>
      </div>
    </v-alert>

    <template v-if="getQuestionCoverType">
      <QuestionBase
        :key="getQuestionCoverType.InterfaceKey"
        :question="getQuestionCoverType"
      />
    </template>
  </v-container>
</template>

<script>
import QuestionBase from "@/components/Questions/QuestionBase";
import { QUESTIONS_MODULE } from "@/store/types/module-types";
import { mapActions, mapGetters } from "vuex";
import { applyThirdPartyId } from "@/common/utils";
import { isNavigatingBack, credentialsUnavailable } from "@/common/navigating";

export default {
  name: "HomeMain",
  components: {
    QuestionBase,
  },
  props: {
    urlParams: Object,
  },
  computed: {
    ...mapGetters(QUESTIONS_MODULE, [
      "getQuestionCoverType",
      "hasCredentials",
      "isSelfServe",
      "isExpired",
      "getQuoteRequestId",
    ]),
  },
  methods: {
    ...mapActions(QUESTIONS_MODULE, [
      "exitToAdviserHub",
      "redirectToCurrentStage",
    ]),
  },
  async mounted() {
    // If there are no credentials in store or URL - impossible to proceed
    if (credentialsUnavailable(this.urlParams, this.hasCredentials))
      this.exitToAdviserHub();
    // No further processing required if user is just navigating back to CoverOptions
    if (isNavigatingBack(this.urlParams, this.getQuoteRequestId)) return;

    applyThirdPartyId(this.isSelfServe, this.urlParams.userId);
    this.redirectToCurrentStage();
  },
};
</script>
